import { inject, Injectable } from '@angular/core';

//Librerías externas
import { AuthService } from '@auth0/auth0-angular';

//Servicios
import { TokenReaderService } from '@/app/services/security/token-reader.service';

/**
 * Punto único de cierre de sesión de la aplicación.
 *
 * Limpia el estado local del usuario y redirige a Auth0 para terminar la
 * sesión (local + Auth0). No cierra la sesión del proveedor de identidad
 * federado (GateOne/Okta): eso requeriría el logout federado, que hoy no está
 * habilitado. El reingreso silencioso por SSO se mitiga forzando la
 * re-autenticación en el login (prompt:'login' en LoginComponent).
 */
@Injectable({
  providedIn: 'root'
})
export class LogoutService {

  private auth0 = inject(AuthService);
  private tokenReader = inject(TokenReaderService);

  /**
   * Limpia los datos del usuario y redirige a Auth0 para terminar la sesión.
   *
   * @param returnTo URL a la que Auth0 regresa al terminar. Debe estar dada de
   * alta en "Allowed Logout URLs" de la aplicación en Auth0.
   */
  cerrarSesion(returnTo: string = window.location.origin): void {
    this.tokenReader.clear();
    this.auth0.logout({ logoutParams: { returnTo } });
  }
}
